exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".oi-donation-form .change-subscription-form[data-v-5c34c46b]{font-size:small;border-bottom:1px solid #aaa;padding-bottom:10px}.oi-donation-form .change-subscription-form .details[data-v-5c34c46b]{margin-bottom:20px}.oi-donation-form .change-subscription-form .message[data-v-5c34c46b]{margin:10px 0}.oi-donation-form .change-subscription-form small.help[data-v-5c34c46b]{margin:0 0 5px;position:relative;top:-5px}", ""]);

// exports
